import { InjectionToken } from '@angular/core';
import { DatastoreConfig } from './datastore.interface';

export const DATASTORE_CONFIG = new InjectionToken<DatastoreConfig>(
  'DatastoreConfig',
);



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/sq/webapp/src/app/@shared/datastore/datastore.config.ts